import { useState } from "react";
import { notifyError } from "src/assets/toastService";
import { customerSummary } from "src/shared/api";
import { errorHandling } from "src/shared/services/errorHandling";
import { LedgerDetails } from "src/shared/types";

function useCustomerSummary() {
  const [summery, setSummery] = useState<LedgerDetails | null>(null);
  const [loading, setLoading] = useState(false);

  const createReport = async (customerId: string, from: string, to: string) => {
    if (!customerId) {
      notifyError("Customer is required");
      return;
    }
    if (!from || !to) {
      notifyError("Please select From and To date");
      return;
    }

    try {
      setLoading(true);
      const res = await customerSummary(customerId, from, to);
      setSummery(res);
      return res;
    } catch (error) {
      errorHandling(error);
      console.error("Customer summary error:", error);
      throw error;
    } finally {
      setLoading(false);
    }
  };

  return { summery, loading, createReport };
}

export default useCustomerSummary;